import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button } from '@material-ui/core';
import { Edit, Link as LinkIcon } from '@material-ui/icons';
import { Typography } from '../../../../../../ui-kit';
import { SmallIconButton } from '../../../common';

interface AttachButtonProps {
    stockCardName?: string | null;
    onClick: () => void;
}

const AttachButton = ({ stockCardName, onClick }: AttachButtonProps) => {
    const { t } = useTranslation();
    const editTooltipTitle = t('Edit');

    if (stockCardName) {
        return (
            <Box display='flex' alignItems='center'>
                <SmallIconButton onClick={onClick} IconComponent={Edit} tooltip={editTooltipTitle} />
                <Typography variant='body2'>{stockCardName}</Typography>
            </Box>
        );
    }

    return (
        <Button
            onClick={onClick}
            variant='outlined'
            color='primary'
            startIcon={<LinkIcon />}
            style={{ textTransform: 'none' }}
        >
            {t('Attach')}
        </Button>
    );
};

export default AttachButton;
